import { useApi } from '@tymely/api';
import { IPolicySet } from '@tymely/atoms';
import { useMutation, useQuery } from '@tanstack/react-query';

const INTENTS_QUERY_KEY = 'intents';
const DECISION_LLM_CLUSTERS_QUERY_KEY = 'decisionLlmClusters';
const UPDATE_INTENT_MUTATION_KEY = 'updateIntent';

export const useIntentsQuery = () => {
    const api = useApi();
    return useQuery<IPolicySet[]>({
        queryKey: [INTENTS_QUERY_KEY],
        queryFn: () => api.get('policy-sets/list', { params: { limit: 1000 } }),
        staleTime: Infinity,
    });
};

export const useUpdateIntentMutation = (onSuccess?: (intent: IPolicySet) => void) => {
    const api = useApi();
    return useMutation({
        mutationKey: [UPDATE_INTENT_MUTATION_KEY],
        mutationFn: (update: { id: IPolicySet['id']; name: string; category: string }) =>
            api.put(`policy-set/${update.id}`, update) as Promise<IPolicySet>,
        onSuccess,
    });
};

export const useDecisionLlmClustersQuery = (organizationId: number, policySetId: number) => {
    const api = useApi();
    return useQuery({
        queryKey: [DECISION_LLM_CLUSTERS_QUERY_KEY, organizationId, policySetId],
        queryFn: () =>
            api.get(`organization/${organizationId}/decision-llm-clusters`, {
                params: { policy_set_id: policySetId },
            }) as Promise<[string, string][]>,
    });
};
